import AmpleHireImageTag from "../ample-hire-html-tags/ample-hire-image-tag";

const NormalButton = ({
  buttonTagCssClasses,
  buttonText,
  onClick = null,
  leftIconSrc = null,
  leftIconAltText = "",
  leftIconCss = "",
  rightIconSrc = null,
  rightIconAltText = "",
  rightIconCSS = "",
  disabled=false,
  ...props
}) => {
  return (
    <button
      className={`btn ${buttonTagCssClasses}`}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {leftIconSrc && (
        <i>
        <AmpleHireImageTag
          imgSrc={leftIconSrc}
          altText={leftIconAltText}
          className={leftIconCss}
        />
        </i>
      )}
      {buttonText}
      {rightIconSrc ? (
        <AmpleHireImageTag
          src={rightIconSrc}
          alt={rightIconAltText}
          className={rightIconCSS}
        />
      ) : (
        <></>
      )}
    </button>
  );
};

export default NormalButton;
